module.exports = __webpack_public_path__ + "img/2025-0408-01-01.be8876a0.png";